export default __webpack_public_path__ + "static/media/Text.3d689d8a.svg";